export enum EShipmentDialogStep {
	INITIAL = 'initial',
	PREVIEW = 'preview',
	S10_EXPECTED = 's10_expected',
}
